import { defineFcm } from '../shared/factory';

export const FCM_SEARCH_USE_VECTOR_COLLECTION = defineFcm('search_use_vector_collection')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		supportedGroups: { global: true, locales: true },
		context: 'Search page',
		description: `Determines whether the search page queries the vector-embedding Typesense collection (petitions_vectors_<lang>) instead of the classic collection.

		This flag allows us to test hybrid text+vector search relevance. A locale value overrides the global value, so it can be enabled for e.g. en-US only.

		Supported languages: English (en) only. Enabling it for any other locale has no effect — the front-end keeps using the classic collection until that language has a vector collection.`,
	});
